// Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../core/material.module';
import { AgmCoreModule } from '@agm/core';
import { TextMaskModule } from 'angular2-text-mask';

// Environment
import { environment } from 'src/environments/environment';

// Services
import { LocationService } from './Services/location.service';

// Directives
import { PlacesAutocompleteDirective } from './places-autocomplete.directive';

// Components
import { LocationListComponent } from './Components/location-list/location-list.component';
import { LocationDetailComponent } from './Components/location-detail/location-detail.component';
import { LocationAddComponent } from './Components/location-add/location-add.component';
import { LocationEditComponent } from './Components/location-edit/location-edit.component';

@NgModule({
    declarations: [
        LocationListComponent, LocationDetailComponent,
        LocationAddComponent, LocationEditComponent,
        PlacesAutocompleteDirective
    ],
    imports: [
        CommonModule, MaterialModule, RouterModule,
        FormsModule, TextMaskModule,

        // Google Maps
        AgmCoreModule.forRoot({
            apiKey: environment.googleMapKey,
            libraries: ['places']
        })
    ],
    providers: [LocationService]
})

export class LocationModule {}